import { shiyong_url } from "@/components/const";
import { PageTitle } from "@/components/pageTitle";

export const Fuwu = () => {
  return (
    <div className="flex justify-center">
      <div className="w-[1920px] px-[150px] pb-[105px]  pt-[60px]">
        <PageTitle title="服务流程" />
        <img src="/imgs/saas/process.png" className="mt-[80px] mx-auto" />
        <div className="flex justify-center mt-[80px]">
          <a href={shiyong_url} target="_blank">
            <div className="w-[196px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] flex items-center justify-center">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#FFFFFF]">
                立即咨询
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
